import { PageLayout } from "../components/PageLayout";
import { CodeBaseIndex } from "../features/codebases/CodeBaseIndex";

export const CodeBaseIndexPage: React.FC = () => {
  return <PageLayout>
    <CodeBaseIndex />
  </PageLayout>;
};